import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import { AuthService } from 'src/api-authorization/auth.service';
import { environment } from 'src/environments/environment';

declare global {
  interface Window {
    hcaptcha: any;
    hcaptchaLoaded: () => void;
  }
}

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrl: './login.component.scss',
  standalone: false
})
export class LoginComponent implements OnInit {
  isLocalhost = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1';
  year = new Date().getFullYear();
  isLoggingIn = false;
  siteKey = environment.hCaptchaSiteKey;
  captchaWidgetId?: number;
  hcaptchaReady = false;

  constructor(
    private http: HttpClient,
    private authService: AuthService,
    private router: Router,
  ) { }

  async ngOnInit() {
    if (!window.hcaptcha) {
      const script = document.createElement('script');
      script.src = 'https://hcaptcha.com/1/api.js?onload=hcaptchaLoaded&render=explicit';
      script.async = true;
      script.defer = true;
      document.head.appendChild(script);
    }

    window.hcaptchaLoaded = () => {
      this.hcaptchaReady = true;
      this.renderCaptcha();
    };

    if (this.authService.isAuthenticated()) {
      this.router.navigate(['/user']);
    }
  }

  renderCaptcha() {
    if (!document.getElementById('captcha-container')) return;

    this.captchaWidgetId = window.hcaptcha.render('captcha-container', {
      sitekey: this.siteKey,
      size: 'invisible',
      callback: (token: string) => this.onVerify(token),
      'error-callback': () => this.onError(),
      'expired-callback': () => this.onExpired()
    });
  }

  triggerCaptcha() {
    this.isLoggingIn = true;

    if (this.hcaptchaReady) {
      window.hcaptcha.execute(this.captchaWidgetId);
    } else {
      this.isLoggingIn = false;
      console.warn('hCaptcha not ready yet');
    }
  }

  onVerify(token: string) {
    if (!token) {
      return;
    }

    this.http.post<{ success: boolean }>('/api/captcha/verify', { token }).subscribe(response => {
      if (response.success) {
        this.login();
      } else {
        this.isLoggingIn = false;
        alert('Captcha verification failed. Please try again.');
      }
    });
  }

  onError() {
    console.error('hCaptcha error occurred');
    // Optionally display a message to the user
    alert('An error occurred while verifying the captcha. Please try again.');

    // Reset the captcha so the user can retry
    if (typeof this.captchaWidgetId === 'number') {
      window.hcaptcha.reset(this.captchaWidgetId);
    }

    this.isLoggingIn = false;
    this.hcaptchaReady = true;
  }

  onExpired() {
    console.warn('hCaptcha token expired');
    // Let the user know the captcha expired
    alert('Captcha expired. Please try again.');

    // Reset so they can trigger it again
    if (typeof this.captchaWidgetId === 'number') {
      window.hcaptcha.reset(this.captchaWidgetId);
    }

    this.isLoggingIn = false;
    this.hcaptchaReady = true;
  }

  async login() {
    this.isLoggingIn = true;
    this.authService.login();
  }
}
